// API client for the rental/checkout flow.
//
// Dispatches to a real backend (realClient.js) when REACT_APP_API_BASE_URL
// is set, otherwise falls back to mock data (mockClient.js) so the flow
// stays clickable with zero setup. See realClient.js for the documented
// route contract this depends on, and README.md for the env vars needed
// to go live (API base URL, Google Maps key for geocoding).

import * as mockClient from "./mockClient";
import * as realClient from "./realClient";

const client = process.env.REACT_APP_API_BASE_URL ? realClient : mockClient;

// Lets pages drop "Demo" messaging once a real backend is configured.
export const IS_MOCK = client === mockClient;

export const searchAddress = client.searchAddress;
export const getSpotsByAddress = client.getSpotsByAddress;
export const getSpot = client.getSpot;
// Only meaningful against the real backend — mock spots are never
// "Partially Available", so this is never actually called in mock mode.
export const getBookedRanges = client === realClient ? realClient.getBookedRanges : async () => [];
export const getBookedRangesBatch = client === realClient ? realClient.getBookedRangesBatch : async () => new Map();
export const signUp = client.signUp;
export const signIn = client.signIn;
export const verifyCode = client.verifyCode;
export const resendCode = client.resendCode;
export const forgotPassword = client.forgotPassword;
export const resetPassword = client.resetPassword;
export const createPaymentIntent = client.createPaymentIntent;
export const createBooking = client.createBooking;
// Only meaningful against the real backend — see realClient.js's doc
// comments on payment-sheet/createBooking for why the checkout flow has to
// create the booking before requesting payment there. Mock mode keeps
// using the single-step createBooking above.
export const createPendingBooking = client === realClient ? realClient.createPendingBooking : undefined;
export const confirmBookingPayment = client === realClient ? realClient.confirmBookingPayment : undefined;
export const cancelPendingBooking = client === realClient ? realClient.cancelPendingBooking : undefined;
export const getProfile = client.getProfile;
export const updateAccountProfile = client.updateAccountProfile;
export const changeAccountPassword = client.changeAccountPassword;
export const getMyBookings = client.getMyBookings;
export const logoutUser = client.logoutUser;
export const deleteAccount = client.deleteAccount;

// Only meaningful against the real backend — a no-op passthrough in mock
// mode since mock signIn/signUp already return a usable token.
export const ensureToken = client === realClient ? realClient.ensureToken : async ({ token }) => token;
